var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialKakaoSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#FEE500"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.583 20C24.805 20 18.5 24.973 18.5 31.108c0 3.966 2.636 7.445 6.601 9.41-.215.745-1.386 4.788-1.433 5.106 0 0-.028.238.127.33.154.09.336.02.336.02.443-.062 5.138-3.361 5.95-3.934.813.115 1.649.175 2.502.175 7.778 0 14.084-4.973 14.084-11.108C46.667 24.974 40.36 20 32.583 20z",
    fill: "#482927"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 63.5,
    height: 63.5,
    rx: 9.75,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgSocialKakaoSquare;